import React from "react";
import BreadCrumbs from "@surgia/ui/components/breadCrumb";
import Button from "@surgia/ui/components/button";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  productName?: string;
  tenantName?: string;
  isLoading?: boolean;
  showBackButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  productName,
  tenantName,
  isLoading = false,
  showBackButton = true,
}) => {
  const navigate = useNavigate();

  const getSubtitle = () => {
    if (isLoading) return "Loading...";
    if (productName && tenantName) return `${productName} - ${tenantName}`;
    return "Product details";
  };

  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full h-[121px] flex-none order-0 self-stretch flex-grow-0 z-0">
      {/* Breadcrumb */}
      <div className="w-full px-4 sm:px-6 pt-6">
        <BreadCrumbs
          items={[
            { label: "Tenants" },
            {
              label: "Tenant details",
            },
            {
              label: "Edit product",
            },
          ]}
        />
      </div>

      {/* Header Content */}
      <div className="w-full px-4 sm:px-6 pb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-1">
              Edit product
            </h1>
            <p className="text-sm text-gray-600">{getSubtitle()}</p>
          </div>
          {showBackButton && (
            <div className="flex items-center gap-4">
              <Button variant="outline" size="sm" onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
